import React from "react";
import { Col, Row, Select, Input } from "antd";
import { FormItem } from "Components/form";
import { PARTNER_TITLES, TENANT_TYPES } from "Constants/";
import { Controller } from "react-hook-form";
import { RULES } from "Constants/rules";

export default function TitleNameSurnameForm({
  form,
  selectedTenantType,
  readOnly = false,
  roles,
  isInstitution,
  ...props
}) {
  const { control, errors } = form;

  return (
    <Row gutter={16}>
      {isInstitution ? null : (
        <Col xs={24} lg={6}>
          <FormItem label="Hitap" htmlFor="title.id">
            <Controller
              control={control}
              name="title.id"
              readOnly={readOnly}
              as={
                <Select
                  style={{ width: "100%" }}
                  className={readOnly ? "readOnly" : undefined}
                >
                  {Object.keys(PARTNER_TITLES).map((d) => (
                    <Select.Option
                      key={PARTNER_TITLES[d]}
                      value={PARTNER_TITLES[d]}
                    >
                      {d}
                    </Select.Option>
                  ))}
                </Select>
              }
            />
          </FormItem>
        </Col>
      )}

      <Col xs={24} md={12} lg={isInstitution ? 12 : 9}>
        <FormItem
          label={isInstitution ? "Ad 1" : "Ad"}
          error={errors.name}
          required={true}
        >
          <Controller
            control={control}
            name="name"
            readOnly={readOnly}
            as={<Input placeholder="Ad giriniz" />}
          />
        </FormItem>
      </Col>

      <Col xs={24} md={12} lg={isInstitution ? 12 : 9}>
        <FormItem
          label={isInstitution ? "Ad 2" : "Soyad"}
          error={errors.surname}
          required={isInstitution ? false : true}
        >
          <Controller
            control={control}
            name="surname"
            readOnly={readOnly}
            as={<Input placeholder="Soyad giriniz" />}
          />
        </FormItem>
      </Col>
    </Row>
  );
}
